module.exports = __webpack_public_path__ + "img/examineApprove.9ee706ca.svg";